import { useAuth } from './hooks/useAuth';
import Login from './components/Login';
import Dashboard from './components/Dashboard';

export default function App() {
  const { session, isAdmin, email, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-ink-300 text-sm">
        <span className="animate-pulse">Conectando…</span>
      </div>
    );
  }

  if (!session) return <Login />;

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-4 p-6 text-center">
        <h1 className="text-2xl font-semibold">Sin acceso</h1>
        <p className="text-ink-300 max-w-md text-sm">
          La sesión <span className="text-ink-100">{email}</span> no está autorizada.
          Este dashboard es privado.
        </p>
      </div>
    );
  }

  return <Dashboard />;
}
